import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc88db8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "max-w-screen-xl mx-auto" }
const _hoisted_4 = { class: "flex flex-wrap -mx-4" }
const _hoisted_5 = { class: "w-full lg:w-1/4 px-3" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "card w-75 shadow-xl" }
const _hoisted_8 = { class: "card-body items-center text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Image Web", -1))
const _hoisted_10 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_11 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_12 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_13 = { class: "card w-75 shadow-xl" }
const _hoisted_14 = { class: "card-body items-center text-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Image Mobile", -1))
const _hoisted_16 = { class: "w-full lg:w-3/4 px-4" }
const _hoisted_17 = { class: "card w-full shadow-xl" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "w-full" }
const _hoisted_20 = {
  key: 0,
  class: "formkit-label"
}
const _hoisted_21 = {
  key: 1,
  class: "formkit-label"
}
const _hoisted_22 = { class: "formkit-label" }
const _hoisted_23 = { class: "formkit-label" }
const _hoisted_24 = { class: "formkit-label" }
const _hoisted_25 = {
  key: 2,
  class: "formkit-label"
}
const _hoisted_26 = { class: "card-actions" }
const _hoisted_27 = { key: 0 }

import {computed, onBeforeMount, ref} from 'vue';
import { useRoute } from 'vue-router';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { useRouter } from "vue-router";
import UploadImage from "@/components/forms/UploadImage.vue";
import {fetchCarouselByUuid} from "@/_services/homepage/carousel";
import {ICarousel} from "@/models/homepage/ICarousel";
import { getItemTypeOptions } from '@/_services/homepage/itemTypeServices.ts'; 

const submitBtnLabel = 'Editer';

export default /*#__PURE__*/_defineComponent({
  __name: 'EditCarousel',
  setup(__props) {

const title = ref<string>("Edition de Carrousel");
const carousel = ref<ICarousel>({} as ICarousel);
const route = useRoute();
const uuidRouteParam = ref<string>("");
const router = useRouter();
const loading = ref<boolean>(true);
const filledFieldCount = ref<number>(0);
const itemTypeOptions = getItemTypeOptions();
const type = computed(() => route.meta?.type as string | undefined)

onBeforeMount(async () => {
    loading.value = true;
    uuidRouteParam.value = route.params.uuid.length ? route.params.uuid as string : "";
    if (uuidRouteParam.value.length) {
        carousel.value = await fetchCarouselByUuid(uuidRouteParam.value);
        await hydrateForm(carousel.value);
        loading.value = false;
    }
});

const form = ref<ICarousel>({
    position: null,
    imageWeb: null,
    imageMobile: null,
    itemType: null,
    itemValue: null,
    pageType: type.value == 'login' ? 'login' : 'homepage',
    domaine: null,
});

const hydrateForm = (carousel: ICarousel) => {
    form.value = {
        position: carousel.position,
        imageWeb: carousel.imageWeb,
        imageMobile: carousel.imageMobile,
        itemValue: carousel.itemValue,
        itemType: carousel.itemType,
        pageType: carousel.pageType,
        domaine: carousel.domaine,
    }
}

const onSubmit = async (formData) => {
    try {
        if (type.value == 'login') {
            if (null == form.value.imageWeb) {
                swal.warning("L'image web est obligatoire.");
                return false;
            }
        } else {
            if (null == form.value.imageWeb || null == form.value.imageMobile) {
                swal.warning('Les deux images sont obligatoires.');
                return false;
            }
        }
        
        filledFieldCount.value = 0;

        const payload = {
            position: parseInt(formData.position),
            imageWeb: null !== form.value.imageWeb ? `${form.value.imageWeb.uuid}` : null,
            imageMobile: null !== form.value.imageMobile ? `${form.value.imageMobile.uuid}` : `${form.value.imageWeb.uuid}`,
            itemValue: formData.itemValue,
            itemType: parseInt(formData.itemType),
            pageType: form.value.pageType,
            domaine: formData.platform ?? 'ce',
        }
        swal.confirm(`Êtes-vous sûr de vouloir éditer un carrousel ?`,
            "Annuler",
            submitBtnLabel
        )
            .then((results) => results.isConfirmed && update(payload))
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

const update = (data) => {
    if(uuidRouteParam.value.length) {
        ApiService.patch('carousels', uuidRouteParam.value, data)
            .then(() => {
                loading.value = false;
                swal.info("Edition avec succès")
                    .then((result) => {
                        if (result.isConfirmed) {
                            router.go(-1);
                        }
                    });
            })
            .catch((axiosError) => {
                swal.error("Une erreur est survenue lors de la modification");
                axiosError.response.data.errors.forEach((error) => {
                    if (error.message.startsWith("Item not found for")
                        || error.message.startsWith("Could not convert database value")) {
                        swal.error("Une erreur est survenue au moment de la modification, l’uuid ajoutée n’existe pas.");
                    }
                });
            });
    }
}

const onCancel = () => {
    swal.confirm(
        "Êtes-vous sûr de vouloir annuler l'édition ?",
        "Oui",
        "Non"
    ).then((result) => {
        if (result.isDismissed) {
            if (type.value && type.value == 'login') {
                router.push({
                    name: "carouselLoginList"
                });
            } else {
                router.push({
                    name: "carouselList"
                });
            }
        }
    });
}

const onImageWebUpload = (image) => {
    form.value.imageWeb = image;
}

const onImageMobileUpload = (image) => {
    form.value.imageMobile = image;
}

const onImageWebRemoved = () => {
    form.value.imageWeb = null;
}

const onImageMobileRemoved = () => {
    form.value.imageMobile = null;
}

const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(title.value) + " " + _toDisplayString(type.value), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                (type.value && type.value !== 'login')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Format requis : 2560 x 696 px"))
                  : _createCommentVNode("", true),
                (type.value && type.value === 'login')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Format requis : 1350 x 1920 px"))
                  : _createCommentVNode("", true),
                _createVNode(UploadImage, {
                  "image-preview-url": form.value.imageWeb ? form.value.imageWeb.url : getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageWebRemoved,
                  onImageUploaded: onImageWebUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ])
            ])
          ]),
          (type.value !== 'login')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(UploadImage, {
                      "image-preview-url": form.value.imageMobile ? form.value.imageMobile.url : getBaseUrl() + '/media/blank2.png',
                      onImageRemoved: onImageMobileRemoved,
                      onImageUploaded: onImageMobileUpload,
                      onError: onImageUploadError
                    }, null, 8, ["image-preview-url"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_FormKit, {
                  type: "form",
                  actions: false,
                  model: form.value,
                  onSubmit: onSubmit,
                  "outer-class": "w-full",
                  "incomplete-message": "Veuillez remplir tous les champs correctement"
                }, {
                  default: _withCtx(({ state: { valid } }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ hidden: type.value === 'login' })
                    }, [
                      _createVNode(_component_FormKit, {
                        type: "select",
                        label: "Type *",
                        name: "itemType",
                        modelValue: form.value.itemType,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.itemType) = $event)),
                        options: _unref(itemTypeOptions),
                        validation: "required",
                        "validation-messages": {
                required: 'Ce champ est obligatoire.'
            }
                      }, null, 8, ["modelValue", "options", "validation-messages"]),
                      (form.value.itemType === '1' || 
                        form.value.itemType === '2' || 
                        form.value.itemType === '5')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_20, " Uuid "))
                        : _createCommentVNode("", true),
                      (form.value.itemType === '4')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_21, "Lien de redirection"))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("label", _hoisted_22, "Si lien de redirection type voyage, veuillez vous assurer de mettre un de ces formats: ", 512), [
                        [_vShow, form.value.itemType === '4']
                      ]),
                      _withDirectives(_createElementVNode("label", _hoisted_23, "https://app.club-employes.com/voyage?id=2209{ce_token} : pour être redirigé vers un produit spécifique où 2209 représente l'id de l'offre voyage", 512), [
                        [_vShow, form.value.itemType === '4']
                      ]),
                      _withDirectives(_createElementVNode("label", _hoisted_24, "https://app.club-employes.com/voyage{ce_token} : pour être redirigé vers la page d'accueil de voyage", 512), [
                        [_vShow, form.value.itemType === '4']
                      ]),
                      (form.value.itemType === '3')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_25, "Mot(s) recherché(s)"))
                        : _createCommentVNode("", true),
                      _createVNode(_component_FormKit, {
                        type: "text",
                        name: "itemValue",
                        value: form.value.itemValue,
                        modelValue: form.value.itemValue,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.itemValue) = $event))
                      }, null, 8, ["value", "modelValue"])
                    ], 2),
                    _createVNode(_component_FormKit, {
                      type: "number",
                      name: "position",
                      label: "Position *",
                      modelValue: form.value.position,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.position) = $event)),
                      validation: "required|min:1",
                      "validation-messages": {
                        required: 'Ce champ est obligatoire.',
                        min: 'Ce champ doit être un nombre décimal superieur à 0',
                }
                    }, null, 8, ["modelValue", "validation-messages"]),
                    (type.value == 'login')
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 0,
                          type: "select",
                          label: "Plateforme *",
                          name: "platform",
                          modelValue: form.value.domaine,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.domaine) = $event)),
                          options: [
                            { label: 'Selectionnez la plateforme', value: null },
                            { label: 'Club Employés', value: 'ce' },
                            { label: 'Gifteo', value: 'gifteo' }
                        ],
                          validation: "required",
                          "validation-messages": {
                            required: 'Ce champ est obligatoire.'
                        }
                        }, null, 8, ["modelValue", "validation-messages"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_26, [
                      (loading.value === false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createVNode(_component_FormKit, {
                              type: "submit",
                              label: submitBtnLabel,
                              disabled: !valid,
                              class: _normalizeClass({ 'btn-primary': true, 'btn-block': true })
                            }, null, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_FormKit, {
                        type: "button",
                        label: "Annuler",
                        onClick: onCancel,
                        class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true })
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})